import { render, staticRenderFns } from "./InsuranceLibraryTab.vue?vue&type=template&id=b10e1490&scoped=true&"
import script from "./InsuranceLibraryTab.vue?vue&type=script&lang=js&"
export * from "./InsuranceLibraryTab.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceLibraryTab.vue?vue&type=style&index=0&id=b10e1490&prod&scoped=true&lang=css&"
import style1 from "./InsuranceLibraryTab.vue?vue&type=style&index=1&id=b10e1490&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10e1490",
  null
  
)

export default component.exports